import { configureStore, combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import businessReducer from './slices/businessSlice'
import workspaceReducer from './slices/workspaceSlice'
import userReducer from './slices/userSlice'

const rootReducer = combineReducers({
  business: persistReducer({ key: 'business', storage }, businessReducer),
  workspace: persistReducer({ key: 'workspace', storage }, workspaceReducer),
  user: persistReducer(
    { key: 'user', storage, blacklist: ['authToken', 'authStateKnown'] },
    userReducer,
  ),
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
